<template>
  <svg
    id="Aquarena_Rutsche"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 600 400"
    style="enable-background:new 0 0 600 400;"
    xml:space="preserve"
  >
    <linearGradient id="grad1_0" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad1_1" x1="30%" y1="10%" x2="80%" y2="100%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad1_2" x1="50%" y1="0%" x2="40%" y2="85%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad1_3" x1="50%" y1="90%" x2="60%" y2="5%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad1_4" x1="95%" y1="0%" x2="10%" y2="0%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad1_5" x1="100%" y1="0%" x2="0%" y2="20%">
      <stop offset="5%" style="stop-color: #f08c1e;stop-opacity:1" />
      <stop offset="20%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="40%" style="stop-color: #8cc83c;stop-opacity:1" />
      <stop offset="60%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="80%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ee82ee;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_0" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_1" x1="30%" y1="10%" x2="80%" y2="100%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_2" x1="50%" y1="0%" x2="40%" y2="85%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_3" x1="50%" y1="90%" x2="60%" y2="5%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_4" x1="95%" y1="0%" x2="10%" y2="0%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad2_5" x1="100%" y1="0%" x2="0%" y2="20%">
      <stop offset="5%" style="stop-color: #00ffff;stop-opacity:1" />
      <stop offset="50%" style="stop-color: #ff00ff;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffff00;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_0" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_1" x1="30%" y1="10%" x2="80%" y2="100%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_2" x1="50%" y1="0%" x2="40%" y2="85%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_3" x1="50%" y1="90%" x2="60%" y2="5%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_4" x1="95%" y1="0%" x2="10%" y2="0%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad3_5" x1="100%" y1="0%" x2="0%" y2="20%">
      <stop offset="5%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #ffffff;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #14b4f0;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #ffffff;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_0" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_1" x1="30%" y1="10%" x2="80%" y2="100%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_2" x1="50%" y1="0%" x2="40%" y2="85%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_3" x1="50%" y1="90%" x2="60%" y2="5%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_4" x1="95%" y1="0%" x2="10%" y2="0%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad4_5" x1="100%" y1="0%" x2="0%" y2="20%">
      <stop offset="5%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #e63232;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #f0dc1e;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #e63232;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_0" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_1" x1="30%" y1="10%" x2="80%" y2="100%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_2" x1="50%" y1="0%" x2="40%" y2="85%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_3" x1="50%" y1="90%" x2="60%" y2="5%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_4" x1="95%" y1="0%" x2="10%" y2="0%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>
    <linearGradient id="grad5_5" x1="100%" y1="0%" x2="0%" y2="20%">
      <stop offset="5%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="30%" style="stop-color: #dc00dc;stop-opacity:1" />
      <stop offset="70%" style="stop-color: #00dcdc;stop-opacity:1" />
      <stop offset="95%" style="stop-color: #dc00dc;stop-opacity:1" />
    </linearGradient>

    <g id="Grundierung">
      <g id="Details_Kopie" data-name="Details Kopie">
        <path
          d="M503.3,309.64a9.8,9.8,0,0,0-2.84-6.74c-2.72-11.48-10.74-23.69-28.72-34.75,1.53.8,2.83,1.62,2.83,1.62a10.07,10.07,0,0,0-5.81-4.5,8.62,8.62,0,0,0-3-.6l-16.6-9.29a9.78,9.78,0,0,0-5.48-4,8.67,8.67,0,0,0-2.81-.6l-34.61-19.36c1.85.9,3.63,2,3.63,2a10,10,0,0,0-5.8-4.5,8.9,8.9,0,0,0-3.35-.61l-10.05-5.61a9.91,9.91,0,0,0-5.58-4.18,8.84,8.84,0,0,0-3-.6c-11-6.17-22.15-12.38-32.7-18.26a37.34,37.34,0,0,1,5,2.64,10,10,0,0,0-5.8-4.5,8.92,8.92,0,0,0-3.64-.6c-12-6.66-23-12.82-32.16-17.9,1.84.9,3.61,2,3.61,2a10.09,10.09,0,0,0-5.81-4.49,8.87,8.87,0,0,0-3.39-.61c-5.05-2.8-9.31-5.15-12.56-6.93h0l-4.91-2.67-.09,0-.71-.39-.06,0a11.17,11.17,0,0,0-.71-1l13.14-8.06a7.82,7.82,0,0,0,5.32-2.07,8.24,8.24,0,0,0,2.56-2.77l8.13-5,2.37-1.38h0c8.13-4.74,14.71-8.66,15.07-9.31q4.59,2.34,9.46,4.43l.33.15h0c2.87,1.22,5.79,2.39,8.77,3.48,1.88.7,3.8,1.36,5.72,2,2.48.82,5,1.61,7.54,2.34,2.25.66,4.53,1.27,6.82,1.85,1.12.29,2.25.56,3.38.83a2.56,2.56,0,0,0,1.19,1.05h0a2.34,2.34,0,0,0,1.19.79,3.05,3.05,0,0,0,2.27-.78,2,2,0,0,1-.64-.14c2,.43,4,.83,6,1.21,1.36.25,2.72.5,4.09.73q3.31.57,6.64,1l.91.12c2.08.28,4.16.54,6.25.76,1.42.15,2.83.29,4.25.42q3.3.3,6.58.49,7.23.42,14.35.38c4.66,0,12.84-.48,12.84-.48s2.56,1.55,4.48.84a3.78,3.78,0,0,0,1.48-1.11h0a3.42,3.42,0,0,0,.22-.28,121,121,0,0,0,28.52-6.08q2.58-.95,5-2c1.59-.71,3.12-1.47,4.57-2.27s2.86-1.68,4.17-2.58c-.38.27-.77.54-1.17.78a18.2,18.2,0,0,1-2,1.23,17,17,0,0,1-1.66.95,15.5,15.5,0,0,0,1.61-.36,17.81,17.81,0,0,0,9.21-6.11,18.19,18.19,0,0,0,3.35-5.57,30.32,30.32,0,0,0,5.37-19c-.07-.79-.17-1.56-.3-2.32a.69.69,0,0,1,0-.13q-.19-1.11-.45-2.19h0a30.2,30.2,0,0,0-8.39-14.56A12.12,12.12,0,0,0,493.11,91c-.15-.14-.32-.25-.49-.38v0l-.69-.53a12.09,12.09,0,0,0-8.75-2.57q-15.54-7.27-41.66-9.82a4.49,4.49,0,0,1,2.06.2c-.77-2.24-2-3-3.4-2.53h0c-.75-.23-2,.48-3.27,1.95a183.57,183.57,0,0,0-57.4,6.13c-1.33-1-2.55-1.35-3.44-.81l.05,0c-1.11.13-2.17.93-3.11,2.6a5.85,5.85,0,0,1,2.13-.61,248.7,248.7,0,0,0-40.3,15.6l-11.67-6.42a42,42,0,0,1,4,2.2,10.05,10.05,0,0,0-5.81-4.49,8.76,8.76,0,0,0-3.49-.61L308,85.38a9.88,9.88,0,0,0-5.56-4.14,8.75,8.75,0,0,0-3.09-.61c-11.86-6.51-29.36-16-29.36-16-1.52-2.32-2.93-3.89-5.23-4.47a9,9,0,0,0-4.14-.58C250.26,54,240.73,49,232.64,44.92a9.64,9.64,0,0,0-5.54-4.26,8.74,8.74,0,0,0-4.17-.54,127.86,127.86,0,0,0-12.51-5.43c-9.68-3.29-35.08-8.26-34.59-8.21a3.55,3.55,0,0,0-2.47-1.79h-.08s-.68,0-1.05-.07a3.47,3.47,0,0,0-2.68,1.17,161.44,161.44,0,0,0-18.38-1,151,151,0,0,0-35.09,4.75,3.19,3.19,0,0,0-2.47-.88l-1.27.26h0A4,4,0,0,0,110,31.2c.33-.08.77-.17,1.23-.26C92.55,36.5,76,46.06,72.5,60.46c-.37.9-.61,1.54-.61,1.54a39.45,39.45,0,0,0,.77,13.27A42.74,42.74,0,0,0,74,80.53,8.37,8.37,0,0,0,74,82.09a10.69,10.69,0,0,0,1.59,5c0-.09,0-.18,0-.27a8.85,8.85,0,0,0,3.72,4,37.66,37.66,0,0,0,8.61,8.7c.67.51,1.35,1,2.06,1.51a66.82,66.82,0,0,0,14.5,7.84A47.57,47.57,0,0,0,111.5,111a14.12,14.12,0,0,0,4.16,1.79,13.27,13.27,0,0,0,6.92-.3c-1.27,0,.41,0,3.09,0l2.41,2.27,13.76,13-1.34,0c-2.71.41-5.3.88-7.81,1.39l-.08-.05c-14.28,3.05-24.5,7.22-32.28,12.22h0c-.93.6-1.8,1.22-2.65,1.84a17.2,17.2,0,0,0-4.51,3c.06-.06.14-.11.2-.16a17.63,17.63,0,0,0-4.16,5.21c.24-.31.47-.62.73-.91a16.57,16.57,0,0,1,2.7-2.91c-5,4.88-7.73,10.14-8.48,15.31-.07-.55-.18,1.86-.18,1.86A20,20,0,0,0,84,167a35.76,35.76,0,0,0,4,14.73,20.91,20.91,0,0,0,3.69,7.88h0A18,18,0,0,0,96,193.73,17.58,17.58,0,0,0,103,196.4c9.89,5.67,23.46,9.13,40.26,10.74a3.06,3.06,0,0,0,1.88,1.4h0a5.18,5.18,0,0,1-1.12-1.32l.14,0a3.23,3.23,0,0,0,2.3,1.64c1.1.06,2.08-1.24,2.08-1.24a2.31,2.31,0,0,1-1.15-.14q6.92.52,14.48.68a190.32,190.32,0,0,0,51-7.34,2.46,2.46,0,0,1-.73.35l-1.56.46a3.55,3.55,0,0,0,3,.85l.08,0h0s.64-.23,1-.33a3.71,3.71,0,0,0,2.14-2.48A215.41,215.41,0,0,0,250,186.2l.71-.36c1.5-.76,3-1.53,4.51-2.34l9,5.07c0,.06.05.13.08.18a10.58,10.58,0,0,0,3.62,3.73l-.17-.22a8.84,8.84,0,0,0,5.49,1.93c-.84-.67,2.54.85,2.56.83l16.1,9a10.69,10.69,0,0,0,3.44,3.44l-.17-.22a8.67,8.67,0,0,0,5.48,1.93c-.74-.6,29.56,16.32,29.56,16.32a10.63,10.63,0,0,0,3.13,3l-.17-.22a8.88,8.88,0,0,0,5.38,1.93l27.84,15.6a10.65,10.65,0,0,0,3.41,3.4,1.84,1.84,0,0,1-.17-.22A8.67,8.67,0,0,0,375,250.9c-.73-.59,10.49,5.66,10.49,5.66a10.79,10.79,0,0,0,3.18,3c-.07-.08-.11-.15-.17-.22a8.8,8.8,0,0,0,5.46,1.93l30.88,17.31a10.7,10.7,0,0,0,3.42,3.41l-.17-.22a8.81,8.81,0,0,0,5.48,1.93c-.74-.59,16.54,9,16.54,9A10.8,10.8,0,0,0,453.4,296l-.17-.22a8.84,8.84,0,0,0,5.49,1.93,3.26,3.26,0,0,0-.92-.6c5.78,3,9.12,6.95,10.48,11.69a8.44,8.44,0,0,0,.58,3.71,2.46,2.46,0,0,0,.07-.29c.48,5.24-1,11.2-4.06,17.61a10.4,10.4,0,0,0-2.34,2.54c.07-.06.15-.1.23-.16a8.75,8.75,0,0,0-2.07,5.25c-1.51,2.47-3.21,5-5.06,7.53a13.2,13.2,0,0,0-7.67,5.5,17.1,17.1,0,0,0-1.71,4.62,17.64,17.64,0,0,1,1.28-2.94,13.28,13.28,0,0,1,6.73-5.33l-.06.08a13.18,13.18,0,0,0-6.64,5.29c-4.09,6.65-.7,17.25,8,22.6s18.85,3.8,23.39-2.56l1.18-1.76a12.3,12.3,0,0,0,2.31-6.79,96.9,96.9,0,0,0,9.67-16c-.49,2.21-3.21,6.3-3.21,6.3a10.09,10.09,0,0,0,4.68-5.73,9.19,9.19,0,0,0,.57-5c4.05-9.41,6.61-19,7.26-26.83A9.92,9.92,0,0,0,503.3,309.64Zm-1.75,4.76c0-.94.06-1.86,0-2.73s-.08-1.94-.17-2.92c.06.12.12.24.17.36C502,310.18,501.8,312.57,501.55,314.4ZM105.26,68.7c0-.1,0-.2.07-.31l0-.13a4.68,4.68,0,0,1,.18-.48c0-.06.06-.12.08-.18s.13-.24.2-.36l.11-.19c.1-.15.2-.29.32-.44l.16-.21c.12-.14.25-.28.4-.43l.19-.18.43-.4.21-.17c.21-.17.42-.33.66-.5l.2-.14c.22-.15.45-.3.69-.44l.18-.11c.29-.18.61-.35.94-.53l.24-.12c.35-.18.72-.37,1.12-.55,1.29-.43,2.58-.83,3.85-1.22a3.46,3.46,0,0,0,2.7.93l.07,0h0s.66-.15,1-.21A4,4,0,0,0,122,59.76c11.18-2.92,21.67-4.27,31.34-3.76,4.86.29,9.12.55,13,.82a3.55,3.55,0,0,0,2.45,2c.44,0,1.3.09,1.3.09h-.17a3.78,3.78,0,0,0,3-1.5c13.47,1.27,22.34,3.48,36.94,10.52a9.81,9.81,0,0,0,2.5,2.19l-.16-.21a8.4,8.4,0,0,0,5.25,1.85,1.21,1.21,0,0,1-.14-.1l.18.1.6.31.65.34.54.28.53.29.25.13.54.28.8.43.61.32c.14.08.28.16.43.23l.32.17.69.37.45.25.31.16.62.34.85.46.62.33.9.49.63.34.89.49.65.36.33.17.55.3.72.4.88.48.73.4,1,.54.55.3.54.3.54.3.65.36,1,.55.68.38.44.24.67.37.56.32h0l1.16.65.55.31,1.1.61.65.37.38.21.93.52.35.2.33.18,1,.59.09.05a10.51,10.51,0,0,0,3.58,3.66l-.17-.22a8.71,8.71,0,0,0,5.49,1.93c-.79-.63,1.13.29,3.87,1.85l0,0,.6.34h0l1.18.68.46.26.92.52.42.24.35.2,1.4.8.33.19,1.42.81.35.2,1.32.76.51.29.49.28.73.42.47.27.9.52.34.19.38.21,1.35.78.23.13c.51.3,1,.59,1.52.87l.07.05,1.21.7.08,0,.47.27,1.26.72.33.19,1.25.73.27.15.72.42.29.16.59.35.68.39.58.33.08.05,1.27.73.32.19.17.09a10.39,10.39,0,0,0,3.14,3l-.17-.22a9,9,0,0,0,5.15,1.94l1.54.89.61.36.36.2.05,0,.18.1c0,.06,6.42,3.74,6.42,3.74h0l.31.18q-4.49,3-9.63,6.3a9.42,9.42,0,0,0-2.27.67h.26a8,8,0,0,0-4.46,3.21,7.83,7.83,0,0,0,1.38-.68c-9.36,5.78-20.11,12-32.11,18.67a246,246,0,0,0-41.19-14.59c-.64-2.23-1.82-3-3.22-2.67h0c-.62-.23-1.63.2-2.77,1.18-8.46-2-17.38-3.71-26.82-5.07l-.78,0V94.44C178.8,88,174.75,83.7,168.23,82.62c-.44-.85-2.34-4.06-7.45-7.18-7.27-4.43-15.44-.79-21.73,7.17l-.12,0A75.22,75.22,0,0,0,127,79.24a14.58,14.58,0,0,0-4.92-2.14,14.18,14.18,0,0,0-2.39-.34l.1,0c-1-.35-3.47-.24-6.3.85l-1-.4c-.88-.39-5.11-2.6-6.7-5.56l.44.7A12.29,12.29,0,0,0,105.26,68.7ZM377,116.9q3-1.25,6.37-2.33a5.55,5.55,0,0,1-1.22.51,3.83,3.83,0,0,0,3.36-.13h0a3.31,3.31,0,0,0,2.32-1.72,170.72,170.72,0,0,1,34.62-5h.15l.65,0c3.91-.1,7.78,0,11.56.18a4,4,0,0,0,2.76,1.39h0a3.91,3.91,0,0,0,3.17-.94,95.9,95.9,0,0,1,15.69,2.81c1.33.37,2.64.77,3.93,1.22l.19.06,1.5.54a39.88,39.88,0,0,1,7.54,3.77c-.22.3-.35.67-.57,1-6.84,3.54-11.71,5.92-23.55,7a9.87,9.87,0,0,0-1.88-.9h0a4.32,4.32,0,0,0-.88-.2c-1.89-.24-4,1.55-4,1.56-4.76.23-10.43.32-17.34.27a147.4,147.4,0,0,1-32.15-4.61,2.48,2.48,0,0,1,1.15.12s-2.07-1.37-2.33-1.43a2.6,2.6,0,0,0-.88,0h0l.05,0a2.57,2.57,0,0,0-1.66.36c-5.76-1.63-9.18-3-9.18-3A2.3,2.3,0,0,1,377,116.9Zm59.17-7.8,0,0Zm34.39,8.32-.57.29c.13-.07.25-.15.41-.22l.13-.09ZM287.67,165.5l0,0h0l.11.06Zm-139.12,8.21a2.67,2.67,0,0,0-1.39.43,3.19,3.19,0,0,0-.61.31c-11.66-1.3-24.16-3.64-26-6.3.25.2.49.4.73.63a12.63,12.63,0,0,0-1-1.3s0-.08,0-.12l.07.07c.17-5,11.94-8.27,27.51-9.44l-.13,0a3.52,3.52,0,0,0,2.79,1.24l.08,0v0s.67-.11,1-.15a3.29,3.29,0,0,0,2.23-1.45,188.74,188.74,0,0,1,42.14,3q3.24.66,6.24,1.45a4.43,4.43,0,0,0,3.17,2.23h0a3.64,3.64,0,0,0,2.71-.42,50.36,50.36,0,0,1,5.3,2.16c-2,.9-4,1.7-6.06,2.43a3.79,3.79,0,0,0-3.11-.81c-.42.12-1.23.4-1.23.4h0a3.65,3.65,0,0,0-2,2.42c-14.36,4.06-28.61,4.74-37.28,5a126.68,126.68,0,0,1-13.91-.71,2.48,2.48,0,0,1,1.2-.12S148.81,173.71,148.55,173.71Zm55.59-10.15,0,0Zm4.36-32.5,0,0Zm1.2-.79Zm-37.22-73c-.42,0-.91-.05-1.4-.1l-.12,0ZM117.8,60.92a2.76,2.76,0,0,1-.83.3l-.38.06ZM495.93,95.78a42.39,42.39,0,0,0-5.68-4.42,11.26,11.26,0,0,1,2.7,1.73C493.91,93.92,495,94.87,495.93,95.78Zm-9.65-7.62h0Zm-1.38,0h0ZM439.62,75.53Zm-1.12.84,0,0Zm-.59.6h0Zm-60.33,5.82,0,0Zm-.74-.2h0ZM232.43,44.82,94.57,145.19l-.29.22ZM89.62,186a.54.54,0,0,0,0,.11A.54.54,0,0,1,89.62,186Zm-.94-2.75c0,.07,0,.15,0,.23C88.71,183.37,88.7,183.29,88.68,183.22Zm.4,1.34.09.29Zm10.42,10a24.8,24.8,0,0,1-4.66-4,42.48,42.48,0,0,0,7.4,5.47A14.56,14.56,0,0,1,99.5,194.54Z"
          style="fill:#ccc"
        />
      </g>
    </g>
    <g id="Tube_Farb-Sektionen_" data-name="Tube (Farb-Sektionen)">
      <path
        id="Abschnitt1"
        :style="{
          fill:
            typeof internalColorArray[0] !== 'undefined'
              ? internalColorArray[0]
              : internalColor
        }"
        :class="{ inactive: index !== 0 && !overview, click: overview }"
        d="M302.4,81.24a8.75,8.75,0,0,0-3.09-.61c-11.86-6.51-29.36-16-29.36-16-1.52-2.32-2.93-3.89-5.23-4.47a9,9,0,0,0-4.14-.58C250.26,54,240.73,49,232.64,44.92a9.64,9.64,0,0,0-5.54-4.26,8.74,8.74,0,0,0-4.17-.54,127.86,127.86,0,0,0-12.51-5.43c-9.68-3.29-35.08-8.26-34.59-8.21a3.55,3.55,0,0,0-2.47-1.79h-.08s-.68,0-1.05-.07a3.47,3.47,0,0,0-2.68,1.17,161.44,161.44,0,0,0-18.38-1,151,151,0,0,0-35.09,4.75,3.19,3.19,0,0,0-2.47-.88l-1.27.26h0A4,4,0,0,0,110,31.2c.33-.08.77-.17,1.23-.26C92.55,36.5,76,46.06,72.5,60.46c-.37.9-.61,1.54-.61,1.54a39.45,39.45,0,0,0,.77,13.27A42.74,42.74,0,0,0,74,80.53,8.37,8.37,0,0,0,74,82.09a10.69,10.69,0,0,0,1.59,5c0-.09,0-.18,0-.27A8.72,8.72,0,0,0,79.57,91c-.46-1-2-2.16-2.88-5.14C75.32,80.51,79.06,75,82.14,72.27c6.51-5.66,14-8.41,19.26-5.84,1.77.86,4.84,5.88,4.84,5.88a12.6,12.6,0,0,0-.64-2.77h0a8.51,8.51,0,0,0-.34-.83h0c0-.1,0-.2.07-.31l0-.13a4.68,4.68,0,0,1,.18-.48c0-.06.06-.12.08-.18s.13-.24.2-.36l.11-.19c.1-.15.2-.29.32-.44l.16-.21c.12-.14.25-.28.4-.43l.19-.18.43-.4.21-.17c.21-.17.42-.33.66-.5l.2-.14c.22-.15.45-.3.69-.44l.18-.11c.29-.18.61-.35.94-.53l.24-.12c.35-.18.72-.37,1.12-.55,1.29-.43,2.58-.83,3.85-1.22a3.46,3.46,0,0,0,2.7.93l.07,0h0s.66-.15,1-.21A4,4,0,0,0,122,59.76c11.18-2.92,21.67-4.27,31.34-3.76,4.86.29,9.12.55,13,.82a3.55,3.55,0,0,0,2.45,2c.44,0,1.3.09,1.3.09h0a3.91,3.91,0,0,0,2.87-1.5c13.47,1.27,22.34,3.48,36.94,10.52a9.81,9.81,0,0,0,2.5,2.19l-.16-.21a8.4,8.4,0,0,0,5.25,1.85,1.21,1.21,0,0,1-.14-.1l.18.1.6.31.65.34.54.28.53.29.25.13.54.28.8.43.61.32c.14.08.28.16.43.23l.32.17.69.37.45.25.31.16.62.34.85.46.62.33.9.49.63.34.89.49.65.36.33.17.55.3.72.4.88.48.73.4,1,.54.55.3.54.3.54.3.65.36,1,.55.68.38.44.24.67.37.56.32h0l1.16.65.55.31,1.1.61.65.37.38.21.93.52.35.2.33.18,1,.59.09.05a10.51,10.51,0,0,0,3.58,3.66l-.17-.22a8.71,8.71,0,0,0,5.49,1.93c-.79-.63,1.13.29,3.87,1.85l0,0,.6.34h0l1.18.68.46.26.92.52.42.24.35.2,1.4.8.33.19,1.42.81.35.2,1.32.76.51.29.49.28.73.42.47.27.9.52.34.19.38.21,1.35.78.23.13c.51.3,1,.59,1.52.87l.07.05,1.21.7.08,0,.47.27,1.26.72.33.19,1.25.73.27.15.72.42.29.16.59.35.68.39.58.33.08.05,1.27.73.32.19.17.09a10.39,10.39,0,0,0,3.14,3l-.17-.22a8.78,8.78,0,0,0,5.49,1.93c-.86-.68-2.79-1-4.85-3.3-3.55-4.11-2.61-10.62-1-14.31,3.38-7.79,8.91-13.42,14.78-13.42,2,0,6.93,3.12,6.93,3.12A10.09,10.09,0,0,0,302.4,81.24ZM117,61.22l-.38.06,1.21-.36A2.76,2.76,0,0,1,117,61.22Zm54.11-4-.12,0,1.52.13C172.06,57.29,171.57,57.26,171.08,57.21Z"
        style="fill:#ccc"
      />
      <g id="Abschnitt2">
        <path
          :style="{
          fill:
            typeof internalColorArray[1] !== 'undefined'
              ? internalColorArray[1]
              : internalColor
        }"
          :class="{ inactive: index !== 1 && !overview, click: overview }"
          d="M505.53,113.35a.69.69,0,0,1,0-.13q-.19-1.11-.45-2.19h0a30.2,30.2,0,0,0-8.39-14.56A12.12,12.12,0,0,0,493.11,91c-.15-.14-.32-.25-.49-.38v0l-.69-.53a12.09,12.09,0,0,0-8.75-2.57q-15.54-7.27-41.66-9.82a4.49,4.49,0,0,1,2.06.2c-.77-2.24-2-3-3.4-2.53h0c-.75-.23-2,.48-3.27,1.95a183.57,183.57,0,0,0-57.4,6.13c-1.33-1-2.55-1.35-3.44-.81l.05,0c-1.11.13-2.17.93-3.11,2.6a5.85,5.85,0,0,1,2.13-.61,248.7,248.7,0,0,0-40.3,15.6c.76.48,1.4,1.4,2.31,1.42a10.78,10.78,0,0,1,9.27,5s16.92,7.83,29.92,10.87a2.3,2.3,0,0,1,.65-.53c2-.83,5.56-1.94,5.15-1.82a3.83,3.83,0,0,0,3.36-.13h0a3.31,3.31,0,0,0,2.32-1.72,170.72,170.72,0,0,1,34.62-5h.15l.65,0c3.91-.1,7.78,0,11.56.18a4,4,0,0,0,2.76,1.39h0a3.91,3.91,0,0,0,3.17-.94,95.9,95.9,0,0,1,15.69,2.81c1.33.37,2.64.77,3.93,1.22l.19.06,1.5.54a39.88,39.88,0,0,1,7.54,3.77c-.22.3-.35.67-.57,1-6.84,3.54-11.71,5.92-23.55,7a9.87,9.87,0,0,0-1.88-.9h0a4.32,4.32,0,0,0-.88-.2c-1.89-.24-4,1.55-4,1.56-4.76.23-10.43.32-17.34.27-12.6-.33-31-4.49-31-4.49s-1.14-.76-1.83-1.17c.57.11.89.16-.09,0a2.6,2.6,0,0,0-.41-.21,2.21,2.21,0,0,0-.68,0l-.15,0a1.47,1.47,0,0,0-.47,0c-2.94.21-7.38,6.81-9.14,12.9-4.78,17.52,0,19.65.39,19.79h0a2.34,2.34,0,0,0,1.19.79,3.05,3.05,0,0,0,2.27-.78,2,2,0,0,1-.64-.14c2,.43,4,.83,6,1.21,1.36.25,2.72.5,4.09.73q3.31.57,6.64,1l.91.12c2.08.28,4.16.54,6.25.76,1.42.15,2.83.29,4.25.42q3.3.3,6.58.49,7.23.42,14.35.38c4.66,0,12.84-.48,12.84-.48s2.56,1.55,4.48.84a3.78,3.78,0,0,0,1.48-1.11h0a3.42,3.42,0,0,0,.22-.28,121,121,0,0,0,28.52-6.08q2.58-.95,5-2c1.59-.71,3.12-1.47,4.57-2.27s2.86-1.68,4.17-2.58c-.38.27-.77.54-1.17.78a18.2,18.2,0,0,1-2,1.23,17,17,0,0,1-1.66.95,15.5,15.5,0,0,0,1.61-.36,17.81,17.81,0,0,0,9.21-6.11,18.19,18.19,0,0,0,3.35-5.57,30.32,30.32,0,0,0,5.37-19C505.76,114.88,505.66,114.11,505.53,113.35Zm-118.41,6.73ZM470,117.71c.13-.07.25-.15.41-.22l.13-.09,0,0Zm20.28-26.35a11.26,11.26,0,0,1,2.7,1.73c1,.83,2,1.78,3,2.69A42.39,42.39,0,0,0,490.25,91.36Z"
          style="fill:#ccc;"
        />
        <path
          :style="{
          fill:
            typeof internalColorArray[1] !== 'undefined'
              ? internalColorArray[1]
              : internalColor
        }"
          :class="{ inactive: index !== 1 && !overview, click: overview }"
          d="M322.13,130l-11.65-6.1a13,13,0,0,1-6.76-3.54l-2.22-1.16q-4.49,3-9.63,6.3a9.42,9.42,0,0,0-2.27.67h.26a8,8,0,0,0-4.46,3.21,7.83,7.83,0,0,0,1.38-.68c-9.36,5.78-20.11,12-32.11,18.67-5.48,1.49-6,3.17-6.67,4,0,0-22.62,10.59-34.5,14.74-2,.9-4,1.7-6.06,2.43a3.79,3.79,0,0,0-3.11-.81c-.42.12-1.23.4-1.23.4h0a3.65,3.65,0,0,0-2,2.42h0a.76.76,0,0,0-.06.16c.49-.15,1.13-.34,1.79-.52,3.38-1,8.19,5.18,10.76,13.75s1.91,16.31-1.47,17.27l-1.56.46a3.55,3.55,0,0,0,3,.85l.08,0h0s.64-.23,1-.33a3.71,3.71,0,0,0,2.14-2.48A215.41,215.41,0,0,0,250,186.2l.71-.36c1.5-.76,3-1.53,4.51-2.34l7.73-4.29a9.9,9.9,0,0,0,9-5.25l16.25-8.8,13.14-8.06a7.82,7.82,0,0,0,5.32-2.07,8.24,8.24,0,0,0,2.56-2.77l8.13-5,2.37-1.38h0c8.13-4.74,14.71-8.66,15.07-9.31l-3.9-2A10.12,10.12,0,0,1,322.13,130Z"
          style="fill:#ccc;"
        />
      </g>
      <g id="Abschnitt3">
        <g :class="{ click: overview }">
          <path
            :style="{
          fill:
            typeof internalColorArray[2] !== 'undefined'
              ? internalColorArray[2]
              : internalColor
        }"
            :class="{ inactive: index !== 2 && !overview, click: overview }"
            d="M210.26,130.07h0c-.62-.23-1.63.2-2.77,1.18-8.46-2-17.38-3.71-26.82-5.07l-.78,0v2l-34.22,6-.78-1.08-.06-2.56-3-2.83-1.34,0c-2.71.41-5.3.88-7.81,1.39l-.08-.05c-14.28,3.05-24.5,7.22-32.28,12.22h0c-.93.6-1.8,1.22-2.65,1.84a17.2,17.2,0,0,0-4.51,3c.06-.06.14-.11.2-.16a17.63,17.63,0,0,0-4.16,5.21c.24-.31.47-.62.73-.91.78-1.08-5,7.23-5.78,12.4-.07-.55-.18,1.86-.18,1.86A20,20,0,0,0,84,167a35.76,35.76,0,0,0,4,14.73A21.3,21.3,0,0,0,91,188.55l.06.1c.23.33.46.66.69,1h0c.25.35.53.68.81,1l.23.26c.25.28.5.54.77.8l.53.5c.21.19.41.38.63.55.42.35.86.69,1.32,1,.28.19.57.37.85.53l.34.19.53.28c.15.08.3.14.45.21l.42.2.54.21.34.14.61.2.27.09.69.2.19.05.76.18.11,0,.84.17h0l.59.1c-.44-.17-.88-.35-1.31-.54a42.48,42.48,0,0,1-7.4-5.47c-5.06-5.67-6.53-13.16-1.83-21,5.28-8.76,16.92-8.64,25.45-2.83a19.49,19.49,0,0,1,2.85,2.08,12.63,12.63,0,0,0-1-1.3s0-.08,0-.12l.07.07c.17-5,11.94-8.27,27.51-9.44l-.13,0a3.52,3.52,0,0,0,2.79,1.24l.08,0v0s.67-.11,1-.15a3.29,3.29,0,0,0,2.23-1.45,188.74,188.74,0,0,1,42.14,3q3.24.66,6.24,1.45a4.43,4.43,0,0,0,3.17,2.23h0a3.64,3.64,0,0,0,2.71-.42,50.36,50.36,0,0,1,5.3,2.16c10.82-3.75,34.06-14.46,34.67-14.9,1.14-1.62,3-3.11,6.5-3.84a246,246,0,0,0-41.19-14.59C212.84,130.51,211.66,129.7,210.26,130.07ZM97.82,193.29a37.59,37.59,0,0,0,3.91,2.46l.5.21-.48-.2h0l-.48-.23-.59-.29a2.69,2.69,0,0,1-.29-.16,7.77,7.77,0,0,1-.87-.53c-.4-.27-.79-.56-1.18-.85l-.18-.13-.32-.27-.09-.06-.69-.58C97.29,192.87,97.56,193.08,97.82,193.29Zm-.87-.71a24.51,24.51,0,0,1-2.11-2.09A24.51,24.51,0,0,0,97,192.58Z"
            style="fill:#ccc;"
          />
          <path
            :style="{
          fill:
            typeof internalColorArray[2] !== 'undefined'
              ? internalColorArray[2]
              : internalColor
        }"
            :class="{ inactive: index !== 2 && !overview, click: overview }"
            d="M449.12,255.38a9.78,9.78,0,0,0-5.48-4,8.67,8.67,0,0,0-2.81-.6l-34.61-19.36c1.85.9,3.63,2,3.63,2a10,10,0,0,0-5.8-4.5,8.9,8.9,0,0,0-3.35-.61l-10.05-5.61a9.91,9.91,0,0,0-5.58-4.18,8.84,8.84,0,0,0-3-.6c-11-6.17-22.15-12.38-32.7-18.26a37.34,37.34,0,0,1,5,2.64,10,10,0,0,0-5.8-4.5,8.92,8.92,0,0,0-3.64-.6c-12-6.66-23-12.82-32.16-17.9,1.84.9,3.61,2,3.61,2a10.09,10.09,0,0,0-5.81-4.49,8.87,8.87,0,0,0-3.39-.61c-5.05-2.8-9.31-5.15-12.56-6.93h0l-4.91-2.67-.09,0-.71-.39-1.28-.66.11.06-.1,0,0,0h0l-15.91,8.82a10.33,10.33,0,0,1-8.92,4.95l-7.66,4.25,9,5.07c0,.06.05.13.08.18a10.58,10.58,0,0,0,3.62,3.73l-.17-.22a8.84,8.84,0,0,0,5.49,1.93c-.84-.67,2.54.85,2.56.83l16.1,9a10.69,10.69,0,0,0,3.44,3.44l-.17-.22a8.67,8.67,0,0,0,5.48,1.93c-.74-.6,29.56,16.32,29.56,16.32a10.63,10.63,0,0,0,3.13,3l-.17-.22a8.88,8.88,0,0,0,5.38,1.93l27.84,15.6a10.65,10.65,0,0,0,3.41,3.4,1.84,1.84,0,0,1-.17-.22A8.67,8.67,0,0,0,375,250.9c-.73-.59,10.49,5.66,10.49,5.66a10.79,10.79,0,0,0,3.18,3c-.07-.08-.11-.15-.17-.22a8.8,8.8,0,0,0,5.46,1.93l30.88,17.31a10.7,10.7,0,0,0,3.42,3.41l-.17-.22a8.81,8.81,0,0,0,5.48,1.93C415.44,280.33,433,239.44,449.12,255.38Z"
            style="fill:#ccc;"
          />
        </g>
      </g>
    </g>
    <g id="Details">
      <path
        id="_35"
        data-name="35"
        d="M471,348.78c-8.77-5.32-19.35-3.25-23.44,3.4s-.7,17.25,8,22.6,18.85,3.8,23.39-2.56C484.33,364.67,479.94,354.2,471,348.78Zm6.44,21.5c-3.62,5.9-12.8,7.17-20.61,2.37s-11.2-13.48-7.57-19.37,12.9-6.79,20.7-2S481.07,364.38,477.44,370.28Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_35-2"
        data-name="35"
        d="M480.12,370.46c5.39-7.56.88-17.78-8.06-23.2-8.77-5.32-20-3.45-24.1,3.2a17.1,17.1,0,0,0-1.71,4.62,17.64,17.64,0,0,1,1.28-2.94c4.09-6.65,14.68-8.72,23.44-3.4,8.95,5.42,13.36,15.93,8,23.48Z"
        style="opacity:0.4"
      />
      <path
        id="_34"
        data-name="34"
        d="M487,334.9c5.91,4.93,7.66,9.58,6.62,13.33.5-1.11,2.87-7.57-5.58-14.48-7.33-6-17.15-7.37-21.61-5a10.64,10.64,0,0,0-3.86,3.55c.07-.06.15-.1.23-.16a5.58,5.58,0,0,1,.39-.46C468.14,326.6,479.69,328.82,487,334.9Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_34-2"
        data-name="34"
        d="M493.58,348.23c1-3.75-.71-8.4-6.62-13.33-7.27-6.08-18.82-8.3-23.81-3.18a5.58,5.58,0,0,0-.39.46,8.71,8.71,0,0,0-2.07,5.45c.72-.85,1.1-2.77,3.46-4.79,4.25-3.48,10.87-2.43,14.61-.76,7.89,3.51,13.54,9.13,13.44,15,0,2-3.3,6.88-3.3,6.88A10.09,10.09,0,0,0,493.58,348.23Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_34-3"
        data-name="34"
        d="M492.07,299.87c7.34,2.29,10.74,5.91,11.23,9.77,0-1.22-.26-8.09-10.72-11.23-9.07-2.73-18.66-.21-21.85,3.72a10.65,10.65,0,0,0-2.2,4.77c0-.09.1-.16.14-.24s.11-.38.19-.58C471.5,299.45,483,297.06,492.07,299.87Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_34-4"
        data-name="34"
        d="M503.3,309.64c-.49-3.86-3.89-7.48-11.23-9.77-9.05-2.81-20.57-.42-23.21,6.21-.08.2-.13.39-.19.58a8.68,8.68,0,0,0,.19,5.82c.34-1.05-.05-3,1.35-5.74,2.59-4.85,9.11-6.42,13.2-6.32,8.64.22,16,3.24,18.17,8.69.73,1.84-.4,7.62-.4,7.62A10.09,10.09,0,0,0,503.3,309.64Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_32"
        data-name="32"
        d="M455.54,272c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.38,5.71-5.88,7.29-7.08,16.93-4.6,21.26A10.69,10.69,0,0,0,453.4,296l-.17-.22c-.15-.13-.31-.24-.47-.38C447.57,290.56,449.59,279.21,455.54,272Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_32-2"
        data-name="32"
        d="M468.76,265.27c-3.77-.95-8.39.84-13.22,6.71-6,7.23-8,18.58-2.78,23.39.16.14.32.25.47.38a8.84,8.84,0,0,0,5.49,1.93c-.86-.69-2.79-1-4.84-3.31-3.56-4.11-2.62-10.61-1-14.31,3.39-7.79,8.91-13.41,14.78-13.41,2,0,6.93,3.12,6.93,3.12A10.07,10.07,0,0,0,468.76,265.27Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_31"
        data-name="31"
        d="M430.42,258.05c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.28-7.07,16.93-4.59,21.25a10.49,10.49,0,0,0,3.62,3.73l-.17-.22a4.12,4.12,0,0,1-.47-.38C422.45,276.63,424.47,265.27,430.42,258.05Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_31-2"
        data-name="31"
        d="M443.64,251.34c-3.77-1-8.39.84-13.22,6.71-5.95,7.22-8,18.58-2.78,23.38a4.12,4.12,0,0,0,.47.38,8.81,8.81,0,0,0,5.48,1.93c-.85-.69-2.78-1-4.84-3.31-3.55-4.11-2.62-10.61-1-14.3,3.38-7.79,8.9-13.42,14.77-13.42,2,0,6.93,3.12,6.93,3.12A10,10,0,0,0,443.64,251.34Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_30"
        data-name="30"
        d="M390.83,235.61c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.29-7.07,16.93-4.59,21.26a10.6,10.6,0,0,0,3.62,3.73c-.07-.08-.11-.15-.17-.22s-.32-.24-.47-.38C382.85,254.19,384.87,242.84,390.83,235.61Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_30-2"
        data-name="30"
        d="M404.05,228.9c-3.77-1-8.39.84-13.22,6.71-6,7.23-8,18.58-2.78,23.39.15.14.31.25.47.38a8.81,8.81,0,0,0,5.48,1.93c-.86-.69-2.78-1-4.84-3.31-3.56-4.11-2.62-10.62-1-14.31,3.38-7.79,8.9-13.41,14.77-13.41,2,0,6.93,3.12,6.93,3.12A10,10,0,0,0,404.05,228.9Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_29"
        data-name="29"
        d="M371.85,225.21c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.29-7.07,16.93-4.59,21.26a10.51,10.51,0,0,0,3.62,3.72,1.84,1.84,0,0,1-.17-.22,5.45,5.45,0,0,1-.47-.37C363.87,243.79,365.89,232.44,371.85,225.21Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_29-2"
        data-name="29"
        d="M385.07,218.5c-3.77-.95-8.39.84-13.22,6.71-6,7.23-8,18.58-2.78,23.39a5.45,5.45,0,0,0,.47.37A8.67,8.67,0,0,0,375,250.9c-.86-.68-2.78-1-4.84-3.3-3.56-4.11-2.62-10.62-1-14.31,3.38-7.79,8.9-13.42,14.77-13.41,2,0,6.93,3.11,6.93,3.11A10,10,0,0,0,385.07,218.5Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_28"
        data-name="28"
        d="M335.39,204.49c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.29-7.07,16.93-4.59,21.26a10.6,10.6,0,0,0,3.62,3.73l-.17-.22c-.16-.13-.32-.24-.47-.38C327.42,223.08,329.44,211.72,335.39,204.49Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_28-2"
        data-name="28"
        d="M348.61,197.78c-3.77-.95-8.39.84-13.22,6.71-5.95,7.23-8,18.59-2.78,23.39.15.14.31.25.47.38a8.81,8.81,0,0,0,5.48,1.93c-.85-.69-2.78-1-4.84-3.31-3.55-4.11-2.62-10.61-1-14.3,3.38-7.8,8.9-13.42,14.77-13.42,2,0,6.93,3.12,6.93,3.12A10,10,0,0,0,348.61,197.78Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_27"
        data-name="27"
        d="M297.39,183.5c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.29-7.07,16.93-4.59,21.26a10.51,10.51,0,0,0,3.62,3.72l-.17-.22a5.45,5.45,0,0,1-.47-.37C289.42,202.08,291.44,190.73,297.39,183.5Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_27-2"
        data-name="27"
        d="M310.61,176.79c-3.77-.95-8.39.84-13.22,6.71-5.95,7.23-8,18.58-2.78,23.39a5.45,5.45,0,0,0,.47.37,8.67,8.67,0,0,0,5.48,1.93c-.85-.68-2.78-1-4.84-3.3-3.55-4.11-2.61-10.62-1-14.31,3.38-7.79,8.91-13.41,14.78-13.41,2,0,6.93,3.11,6.93,3.11A10.09,10.09,0,0,0,310.61,176.79Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_26"
        data-name="26"
        d="M263.38,179.23c-.73,3.87-.41,7.36.83,9.52a10.58,10.58,0,0,0,3.62,3.73l-.17-.22c-.15-.13-.31-.24-.46-.38-3-2.75-3.57-7.76-2.43-12.8Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_26-2"
        data-name="26"
        d="M264.78,179.06c-1.13,5-.55,10.08,2.42,12.82.15.14.31.25.46.38a8.84,8.84,0,0,0,5.49,1.93c-.86-.69-2.79-1-4.84-3.31-2.87-3.31-2.8-8.52-1.82-12.21A7.48,7.48,0,0,1,264.78,179.06Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_25"
        data-name="25"
        d="M201.63,146c-1.86,9.75.75,21.9,7.22,17.51-4.1-.52-7.49-5-5.51-16.63,1.72-10.14,5.36-16,10.16-14.09C211.53,125.74,204.2,132.57,201.63,146Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_25-2"
        data-name="25"
        d="M201.63,146c1.74-9.11,5.67-15.17,8.63-15.94h0c-2.19-.81-9,6.25-10.21,18.11-1,9.74,2.12,16,5.45,16.17h0C201.53,163.23,200.13,153.84,201.63,146Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_24"
        data-name="24"
        d="M152.42,133.08a34.37,34.37,0,0,1,2,8.84c.77,8.43-1.46,15.54-5,15.89-.45,0-1.15.13-1.64.2a3.52,3.52,0,0,0,2.79,1.24c3.52-.34,5.68-8.2,4.83-17.55a42.32,42.32,0,0,0-1.77-8.82Z"
        style="opacity:0.4"
      />
      <path
        id="_24-2"
        data-name="24"
        d="M153.65,132.88a44.08,44.08,0,0,1,1.77,8.82c.85,9.35-1.31,17.21-4.83,17.55l.08,0h0v0s.67-.11,1-.15c3.49-.34,5.62-8.2,4.76-17.55a44,44,0,0,0-1.75-8.86Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_21"
        data-name="21"
        d="M141.68,189.32c.95-7.56,3.08-14.13,6-15.22l0-.06c-3,.05-6.34,8-6.9,14.8-1.32,19.22,4.28,19.7,4.28,19.7h0C142.37,206.38,140.56,198.2,141.68,189.32Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_21-2"
        data-name="21"
        d="M141.68,189.1c-1.29,10.25,1.31,19.58,4.74,19.77,1.1.06,2.08-1.24,2.08-1.24s-6.36,1.29-4.86-16.73c1.42-17.62,7.48-16.23,7.48-16.23s-2.31-1-2.57-1C145.18,173.7,142.72,180.82,141.68,189.1Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_20"
        data-name="20"
        d="M202.84,170.16c3.38-1,8.19,5.18,10.76,13.75s1.91,16.31-1.47,17.27l-1.56.46a3.55,3.55,0,0,0,3,.85c3.37-1,4.18-10,1.33-19.51s-8.27-15.91-11.65-14.94a3.61,3.61,0,0,0-2.21,2.64C201.54,170.53,202.18,170.34,202.84,170.16Z"
        style="opacity:0.4"
      />
      <path
        id="_20-2"
        data-name="20"
        d="M203.26,168c3.38-1,8.8,5.42,11.65,14.94s2.05,18.41-1.26,19.48h0s.64-.23,1-.33c3.34-1,4.06-9.9,1.21-19.41s-8.18-16-11.53-15c-.42.12-1.23.4-1.23.4h0A1.15,1.15,0,0,1,203.26,168Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_19"
        data-name="19"
        d="M270.58,163c2.26,7,1.3,11.59-1.46,14,1-.62,6.2-4.47,2.89-14.37-2.87-8.6-10.13-14.85-15-15.29a10.08,10.08,0,0,0-4.95.77l.27,0c.19,0,.36-.11.56-.15C259.57,146.57,267.79,154.4,270.58,163Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_19-2"
        data-name="19"
        d="M269.12,177c2.76-2.42,3.72-7,1.46-14-2.79-8.63-11-16.46-17.67-15.05-.2,0-.37.1-.56.15a8.05,8.05,0,0,0-4.46,3.22c1-.29,2.31-1.61,5.25-2,5.23-.5,10.06,3.81,12.24,7.09,4.59,6.94,6.29,14.34,3.21,18.92-1,1.54-5.85,3.8-5.85,3.8A8.7,8.7,0,0,0,269.12,177Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_18"
        data-name="18"
        d="M308.09,141c2.26,7,1.3,11.59-1.46,14,1-.62,6.2-4.47,2.89-14.37-2.87-8.6-10.13-14.85-15-15.29a10,10,0,0,0-4.94.77h.26a5.15,5.15,0,0,1,.56-.16C297.08,124.56,305.31,132.39,308.09,141Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_18-2"
        data-name="18"
        d="M306.63,155c2.76-2.42,3.72-7,1.46-14-2.78-8.63-11-16.46-17.67-15.05a5.15,5.15,0,0,0-.56.16,8,8,0,0,0-4.46,3.21c1-.29,2.31-1.61,5.25-2,5.23-.5,10.06,3.81,12.24,7.09,4.59,6.94,6.29,14.34,3.21,18.92-1,1.54-5.59,3.71-5.59,3.71A8,8,0,0,0,306.63,155Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_17"
        data-name="17"
        d="M386.69,97.06c2.73,8.52,2.31,20.44-4.57,18,3.34-1,6.53-5.11,2.34-18.09-3.38-10.45-6.9-14.07-11.46-11.81C377.21,77.71,383.67,87.63,386.69,97.06Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_17-2"
        data-name="17"
        d="M387.56,97c-2.47-8.88-8.67-16.16-11.5-14.43l.05,0c3.82-.44,8.24,7.16,10.58,14.48,2.18,6.82,2.35,15.81-1.2,17.89h0C389.18,114.39,390.33,107,387.56,97Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_16"
        data-name="16"
        d="M432.55,91.74c-1.25,9.84,2.12,21.82,8.3,17-4.13-.27-7.78-4.47-6.54-16.25,1.09-10.24,4.35-16.31,9.26-14.7C441.17,70.89,434.28,78.17,432.55,91.74Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_16-2"
        data-name="16"
        d="M432.55,91.74c1.17-9.2,4.71-15.49,7.62-16.45h0c-2.24-.68-8.59,6.79-9.06,18.71-.39,9.78,3.11,15.79,6.44,15.79h0C433.53,108.94,431.55,99.65,432.55,91.74Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_15"
        data-name="15"
        d="M471,115.57c-3.7-5.17-3.17-13.19,1.69-19.09,5.55-6.75,14.6-8.27,20.22-3.39,1.21,1,2.62,2.3,3.73,3.42A12,12,0,0,0,493.11,91c-5.87-5.1-15.6-3.18-21.73,4.28-5.73,7-6.29,16.31-1.55,21.66Z"
        style="opacity:0.4"
      />
      <path
        id="_15-2"
        data-name="15"
        d="M469.83,116.9c-4.74-5.35-4.18-14.69,1.55-21.66,6-7.26,15.33-9.25,21.24-4.66v0l-.69-.53c-6-4.91-15.83-2.77-21.73,4.87-5.67,7.33-5.79,17-.47,22.13Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_14"
        data-name="14"
        d="M469.66,117.13a17.94,17.94,0,1,1,18.24,29.21,15.5,15.5,0,0,1-1.61.36,17,17,0,0,0,1.66-.95,18.2,18.2,0,0,0,2-1.23,16.24,16.24,0,0,0,2.05-1.46,16.7,16.7,0,1,0-20.06-26.65l-.36.24c-.2.13-.38.3-.58.43s-.38.28-.61.41-.5.3-.78.43-.41.22-.6.31C469.25,117.89,469.38,117.45,469.66,117.13Z"
        style="opacity:0.4"
      />
      <path
        id="_14-2"
        data-name="14"
        d="M500.38,124.23a17.92,17.92,0,0,0-30.72-7.1,17.92,17.92,0,0,1,31.3,6.39,18,18,0,0,1-3.85,16.71A17.94,17.94,0,0,0,500.38,124.23Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_13"
        data-name="13"
        d="M438.66,125.74c7.42-1.59,10.67,7.68,11.12,15.7,1.14,18.73-7.09,15.8-7.09,15.8s2.56,1.55,4.48.84c2.5-.91,5.33-6.58,4.13-18-.83-7.93-4.11-15.36-8.61-15.91C440.79,123.93,438.66,125.74,438.66,125.74Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <g id="_13-2" data-name="13" style="opacity:0.4">
        <path
          d="M451.3,140.08a34.84,34.84,0,0,1-.6,12.64,27.9,27.9,0,0,0,1.47-15.05c-1.21-6.5-3.61-11.53-8.6-13.3h0C447.62,125.72,450.52,132.68,451.3,140.08Z"
          style="fill:#fff"
        />
        <polygon
          points="448.64 156.98 448.64 156.98 448.65 156.97 448.64 156.98"
          style="fill:#fff"
        />
      </g>
      <path
        id="_12"
        data-name="12"
        d="M378.31,133.55c2.38-7.08,5.73-13,8.81-13.47l.05,0c-2.92-.54-7.75,6.46-9.61,12.88-5,18.25.42,19.8.42,19.8h0C375.72,150.11,375.51,141.88,378.31,133.55Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_12-2"
        data-name="12"
        d="M378.31,133.55c-3.23,9.62-2.47,19.1.86,19.95a3.05,3.05,0,0,0,2.27-.78s-6.47,0-1.55-17.05c4.78-16.68,10.44-14.16,10.44-14.16s-2.07-1.37-2.33-1.43C384.7,119.42,380.92,125.79,378.31,133.55Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_11"
        data-name="11"
        d="M327.47,108.94c4.84-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.61-2.68-14.38,5.71-5.88,7.28-7.08,16.93-4.6,21.26a10.6,10.6,0,0,0,3.62,3.72l-.17-.22c-.15-.12-.31-.23-.47-.37C319.5,127.52,321.52,116.17,327.47,108.94Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_11-2"
        data-name="11"
        d="M340.69,102.23c-3.77-1-8.38.84-13.22,6.71-6,7.23-8,18.58-2.78,23.39.16.14.32.25.47.37a8.84,8.84,0,0,0,5.49,1.93c-.86-.69-2.79-1-4.84-3.3-3.56-4.11-2.62-10.62-1-14.31,3.39-7.79,8.91-13.42,14.78-13.42,2,0,6.93,3.12,6.93,3.12A10.09,10.09,0,0,0,340.69,102.23Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_10"
        data-name="10"
        d="M308.16,98.16c4.83-5.86,9.45-7.65,13.22-6.7-1.12-.47-7.62-2.68-14.39,5.7-5.88,7.29-7.07,16.94-4.59,21.26a10.49,10.49,0,0,0,3.62,3.73l-.17-.22c-.16-.13-.31-.23-.47-.38C300.19,116.75,302.21,105.39,308.16,98.16Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_10-2"
        data-name="10"
        d="M321.38,91.46c-3.77-.95-8.39.84-13.22,6.7-6,7.23-8,18.59-2.78,23.39.16.15.31.25.47.38a8.84,8.84,0,0,0,5.48,1.93c-.85-.69-2.78-1-4.84-3.31-3.55-4.11-2.61-10.61-1-14.3,3.38-7.79,8.91-13.42,14.78-13.42,2,0,6.93,3.12,6.93,3.12A10.05,10.05,0,0,0,321.38,91.46Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_9"
        data-name="9"
        d="M289.18,88c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.28-7.07,16.93-4.59,21.26a10.51,10.51,0,0,0,3.62,3.72l-.17-.22c-.16-.12-.31-.23-.47-.37C281.21,106.53,283.23,95.18,289.18,88Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_9-2"
        data-name="9"
        d="M302.4,81.24c-3.77-.95-8.39.84-13.22,6.71-5.95,7.23-8,18.58-2.78,23.39.16.14.31.25.47.37a8.78,8.78,0,0,0,5.49,1.93c-.86-.68-2.79-1-4.85-3.3-3.55-4.11-2.61-10.62-1-14.31,3.38-7.79,8.91-13.42,14.78-13.42,2,0,6.93,3.12,6.93,3.12A10.09,10.09,0,0,0,302.4,81.24Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_8"
        data-name="8"
        d="M251.5,66.86c4.83-5.87,9.45-7.66,13.22-6.71-1.12-.47-7.62-2.68-14.39,5.71-5.88,7.29-7.07,16.93-4.59,21.26a10.51,10.51,0,0,0,3.62,3.72l-.17-.22c-.16-.12-.31-.23-.47-.37C243.53,85.44,245.55,74.09,251.5,66.86Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_8-2"
        data-name="8"
        d="M264.72,60.15c-3.77-.95-8.39.84-13.22,6.71-5.95,7.23-8,18.58-2.78,23.39.16.14.31.25.47.37a8.71,8.71,0,0,0,5.49,1.93c-.86-.68-2.79-1-4.85-3.3-3.55-4.11-2.61-10.62-1-14.31,3.38-7.79,8.91-13.42,14.78-13.41,2,0,6.35,3.09,6.35,3.09C268.43,62.3,267,60.73,264.72,60.15Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_7"
        data-name="7"
        d="M214.43,47.09c4.63-5.63,9.06-7.34,12.67-6.43-1.07-.45-7.3-2.57-13.79,5.47-5.63,7-6.78,16.23-4.4,20.37a10.15,10.15,0,0,0,3.47,3.57l-.16-.21c-.15-.12-.3-.22-.45-.36C206.79,64.9,208.73,54,214.43,47.09Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_7-2"
        data-name="7"
        d="M227.1,40.66c-3.61-.91-8,.8-12.67,6.43-5.7,6.92-7.64,17.81-2.66,22.41.15.14.3.24.45.36a8.4,8.4,0,0,0,5.25,1.85c-.82-.66-2.67-1-4.64-3.17-3.4-3.94-2.5-10.17-1-13.71C215.11,47.37,220.4,42,226,42c1.9,0,6.65,3,6.65,3A9.62,9.62,0,0,0,227.1,40.66Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_3"
        data-name="3"
        d="M88.15,66c7-3.27,11.91-2.89,14.87-.37-.8-.92-5.65-5.79-15.47-1C79,68.72,73.65,77,74,82.09a10.69,10.69,0,0,0,1.59,5c0-.09,0-.18,0-.27s-.18-.36-.25-.55C72.71,79.58,79.58,70.06,88.15,66Z"
        style="opacity:0.4"
      />
      <path
        id="_3-2"
        data-name="3"
        d="M103,65.66c-3-2.52-7.91-2.9-14.87.37-8.57,4-15.44,13.55-12.9,20.23.07.19.16.36.25.55A8.72,8.72,0,0,0,79.57,91c-.46-1-2-2.16-2.88-5.14C75.32,80.51,79.06,75,82.14,72.27c6.51-5.66,14-8.41,19.26-5.84,1.77.86,4.84,5.88,4.84,5.88A10,10,0,0,0,103,65.66Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_6"
        data-name="6"
        d="M171.08,57.21c-3.49-.37-5.63-8.32-4.77-16.59s4.4-14.67,7.89-14.31l1.63.17a3.55,3.55,0,0,0-2.47-1.79c-3.49-.36-7.1,6.78-8.06,16s1.1,17.85,4.6,18.22A3.81,3.81,0,0,0,173,57.34C172.47,57.32,171.76,57.28,171.08,57.21Z"
        style="opacity:0.4"
      />
      <path
        id="_6-2"
        data-name="6"
        d="M169.9,58.86c-3.5-.37-5.56-9-4.6-18.22s4.51-16.2,8-15.95h0s-.68,0-1.05-.07c-3.46-.36-7,6.78-8,16s1.08,17.85,4.54,18.21c.44,0,1.3.09,1.3.09h-.17Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_6-3"
        data-name="6"
        d="M111.8,30.83c3.46-.59,7.63,6.45,9,14.59s-.35,15.21-3.82,15.8l-1.61.27a3.58,3.58,0,0,0,2.86,1c3.46-.58,5-8.37,3.54-17.4S116,28.35,112.51,28.93A3.78,3.78,0,0,0,110,31.2C110.44,31.09,111.13,30.94,111.8,30.83Z"
        style="opacity:0.4"
      />
      <path
        id="_6-4"
        data-name="6"
        d="M112.51,28.93c3.46-.58,7.75,7.18,9.25,16.21s-.06,16.7-3.47,17.38h0s.66-.15,1-.21c3.43-.58,5-8.37,3.49-17.4S117,28.13,113.61,28.7l-1.27.26h0Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_2"
        data-name="2"
        d="M103.6,91.16c1.61-8.92,8.55-14.9,16.1-14.4l.1,0c-2.25-.84-13.14.9-16.49,11.92a19.86,19.86,0,0,0,7.57,21.93C105.32,106.68,102.19,99,103.6,91.16Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_2-2"
        data-name="2"
        d="M118.71,112.21c-8.72-2.16-14.9-9.43-13.39-20.92,1.34-10.24,10.67-14.6,19.39-12.44a15.79,15.79,0,0,1,3,.85,14.17,14.17,0,0,0-5.58-2.6c-8.44-2.08-16.71,4.21-18.49,14.06s3.63,19.53,12.06,21.62a13.27,13.27,0,0,0,6.92-.3A15,15,0,0,1,118.71,112.21Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_2-3"
        data-name="2"
        d="M91.21,168.66a18,18,0,0,1,22.67-6.08H114c-2.1-1.76-14.42-5-22.16,3.64-7.31,8.12-3.94,18.48-.11,23.38A18,18,0,0,1,91.21,168.66Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_2-4"
        data-name="2"
        d="M99.5,194.54c-8.53-5.81-12.42-15.17-6.49-25,5.28-8.76,16.92-8.64,25.45-2.83a19.49,19.49,0,0,1,2.85,2.08,17.68,17.68,0,0,0-5-4.84,18,18,0,1,0-12.75,32.56A20.13,20.13,0,0,1,99.5,194.54Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="Eingang"
        d="M164.78,82.33a19.45,19.45,0,0,0-19.48,19.89l.4,21.5-18.16-16.8-1.91.08,20.12,19.65.14,7.57,34-6V94.44C178.62,86.87,173.33,82.33,164.78,82.33Zm12.54,40.89c-.08,1.74-.8,2.9-2.34,3.34l-23.66,4.22c-1.38.51-2.56.11-3.45-1.56V104.11c0-10.22,7.46-19.55,17.67-19.55,8.23,0,11.78,5.33,11.78,15.44Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M125.62,107c2.1,2.47.85,6.25.85,6.25l18.36,17.36.06,2.56,1,1-.17-7.43Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="_23"
        data-name="23"
        d="M90,150.42a16.55,16.55,0,0,1,28.87,15.63l.08,0c.37.11.72.25,1.07.39a18,18,0,0,0,1.39-5.94,17.33,17.33,0,0,0-16.09-18.47,17.09,17.09,0,0,0-16,9.27C89.47,151,89.7,150.71,90,150.42Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="_23-2"
        data-name="23"
        d="M105.57,141.71a16.67,16.67,0,0,0-12.38,4.57,16.8,16.8,0,0,1,12.09-4.22,17.33,17.33,0,0,1,16.09,18.47,17.68,17.68,0,0,1-1.38,5.94h0a18.32,18.32,0,0,0,1.52-6.3C122.07,150.51,114.93,142.24,105.57,141.71Z"
        style="opacity:0.4"
      />
    </g>
    <g id="Schatten_Lichter" data-name="Schatten &amp; Lichter">
      <path
        id="Schatten_Ausgang"
        data-name="Schatten Ausgang"
        d="M477.49,370.59a.38.38,0,0,1-.16.15c-.51.18-1.36-1.56-2.87-3.62-.58-.78-1.09-1.39-1.44-1.79a28.74,28.74,0,0,0-8.35-6.62,43.72,43.72,0,0,0-12-4.29s-3.69-.83-3.45-1.22c3.63-5.9,12.89-6.79,20.7-2S481.12,364.69,477.49,370.59Z"
        style="fill:#1d1d1b;opacity:0.6000000000000001"
      />
      <path
        id="Schatten_Eingang"
        data-name="Schatten Eingang"
        d="M149.5,117.32c-.78,2.78-1.09,6-1.63,11.9V104.11c0-10.22,7.46-19.55,17.67-19.55,8.23,0,11.78,5.33,11.78,15.44C177.81,75.7,150.28,114.54,149.5,117.32Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        d="M410.61,135.24c-11.35-1.92-22.17-4.05-29.08-4.51-.55,1.42-1.1,3.05-1.64,4.94q-.22.77-.42,1.5c5.67,2.31,15.22,4.48,26.49,6.37,18.7,3.16,36-.62,36.71-4.71S429.32,138.39,410.61,135.24Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M377.56,132.92c.22-.75.48-1.52.77-2.28-2.6.08-4.19.6-4.38,1.78s.83,2.35,2.85,3.49C377,135,377.27,134,377.56,132.92Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M384.45,97q-.93-2.86-1.87-5c-3.27,1.29-5.17,2.64-5,3.8S380.44,97.07,384.45,97Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M399.62,87.88A88,88,0,0,0,385.23,91a34.14,34.14,0,0,1,2.28,5.86c5.93-.35,13.53-1.28,20-2.17,12.54-1.74,21.06-2.9,20.7-5.5S412.15,86.14,399.62,87.88Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M213.6,183.91c-.33-1.12-.71-2.19-1.11-3.22-5.42.73-13,1.83-22.41,2.64-15.36,1.33-32.41,3.58-32.41,6.11s15.66,5.56,37.33.89c8.64-1.86,14.81-3.36,19.09-4.65C213.94,185.1,213.78,184.51,213.6,183.91Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M215.07,180.36c.28.77.55,1.55.79,2.37s.42,1.46.59,2.19c4.41-1.51,6.05-2.76,6.05-4S220,179.76,215.07,180.36Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M153.5,140.17c-.07.45.23.81.85,1.1-.08-.71-.18-1.41-.3-2.11A2.12,2.12,0,0,0,153.5,140.17Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M181.4,134.22c-11-1.78-21,.8-25.46,3.46a38.72,38.72,0,0,1,.54,3.87l0,.33c5.27,1,16.6.91,27.16,2.62a127.88,127.88,0,0,0,16.64,1.79,32.38,32.38,0,0,1,1.89-6.94A120,120,0,0,0,181.4,134.22Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M204.89,140.43a44.45,44.45,0,0,0-1.43,5.83c3.51-.18,5.62-.88,5.83-2.18C209.46,143,207.78,141.73,204.89,140.43Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M306,122.15l-.17-.22a8.94,8.94,0,0,0,4.54,1.88l-6.5-3.41A10.35,10.35,0,0,0,306,122.15Z"
        style="opacity:0.2"
      />
      <path
        d="M320.5,123.57c-8.12-4-14-7.13-14.75-7.71l-1.24.85a9.53,9.53,0,0,0,2,3.84c2.06,2.28,4,2.62,4.84,3.31a6.23,6.23,0,0,1-.94,0L322.26,130c-.19-.26-.37-.54-.55-.84A11.6,11.6,0,0,1,320.5,123.57Z"
        style="opacity:0.2"
      />
      <path
        d="M334,130c-3.7-1.72-7.28-3.44-10.57-5a10.64,10.64,0,0,0,2.41,6.33,10.79,10.79,0,0,0,1.44,1.33l7.26,3.81c.33-.43.22.14.24.11a188.09,188.09,0,0,0,42,15.09c-.67-1-1.37-2.8-1.34-6.22A244.51,244.51,0,0,1,334,130Z"
        style="opacity:0.2"
      />
      <path
        d="M442.88,150.63c-22.49,1.69-42.66,1-64.83-4.52,0,4.78,1.76,6.1,2.75,6.47a222.71,222.71,0,0,0,62.87,4.59l2-.17c1.5-.71,3.14-2.54,3.85-7Q446.27,150.37,442.88,150.63Z"
        style="opacity:0.2"
      />
      <path
        d="M499.22,128.72c-8.46,11.5-25.57,18.25-47.56,21a28.71,28.71,0,0,1-1,3h0a11.51,11.51,0,0,1-1.83,4c17.66-1.84,32.43-6.11,42.52-13.17l.59-.46A16.66,16.66,0,0,0,499.22,128.72Z"
        style="opacity:0.2"
      />
      <path
        d="M500.48,134.61a30.24,30.24,0,0,0,5.35-18.94,31.63,31.63,0,0,0-.77-4.64,30.43,30.43,0,0,1-3.69,14.34A17.89,17.89,0,0,1,500.48,134.61Z"
        style="opacity:0.2"
      />
      <path d="M302.3,118.22l-1.11.77,2.7,1.41a10.12,10.12,0,0,1-1.49-2Z" style="opacity:0.2" />
      <path
        d="M207.75,60.92c-15.18-7-24.32-8.6-40.87-9.77.82,3.38,2.26,5.74,4.08,6l1.52.13.48,0,0,0c13.47,1.27,22.35,3.49,36.94,10.52a10.14,10.14,0,0,1-1-1.38A11.28,11.28,0,0,1,207.75,60.92Z"
        style="opacity:0.2"
      />
      <path
        d="M244.55,80.54c-11.29-6.36-21.73-12.11-28.78-15.71-1.84-.93-3.58-1.8-5.25-2.61a10.29,10.29,0,0,0,2.31,6.32c1.87,2.07,3.62,2.48,4.5,3.07l.18.1.6.31.65.34.6.32.72.38.54.28.8.43.62.33.74.39.69.37.76.41.62.34.85.46.62.33.87.48.67.36.87.47.67.37.87.47L231,79l.82.45.76.41,1,.53.61.34,1,.57.65.36,1,.55.68.38,1.07.59.6.34,1.1.61.64.36,1,.58.71.39,1.3.73.36.2,1.36.77.09.05,0-.06A12.41,12.41,0,0,1,244.55,80.54Z"
        style="opacity:0.2"
      />
      <path d="M305.75,115.86l-1.59-.93a11.92,11.92,0,0,0,.35,1.78Z" style="opacity:0.2" />
      <path
        d="M285.1,103.8a10.72,10.72,0,0,0,2.41,6.54c2.06,2.28,4,2.62,4.85,3.3H292l1.54.89.7.41.32.19.39.22.61.36.3.17.54.31.28.17c.49.28.94.54,1.35.79l.2.11,2,1.16.95.56,1.11-.77a11.37,11.37,0,0,1-1.11-5C297.52,111,291.86,107.73,285.1,103.8Z"
        style="opacity:0.2"
      />
      <path
        d="M282.22,102.13c-10.41-6-23-13.27-34.82-20a11,11,0,0,0,2.43,7.1c.17.18.33.33.49.49l8.24,4.67.62.35,1.17.67.48.27,1.32.75.37.21,1.4.8.33.19,1.42.81.35.2,1.32.76.51.29,1.21.69.48.28,1.2.69.48.27,1.22.7.41.24,1.28.73.33.19,1.16.67.58.33,1.09.63.39.23,1.11.63.53.31.89.51.64.37,1.21.7.11.06,1.13.66.44.25.16.09a7.67,7.67,0,0,1-.48-.73A11.89,11.89,0,0,1,282.22,102.13Z"
        style="opacity:0.2"
      />
      <path
        d="M104.51,67.36a9.52,9.52,0,0,1,.75,1.33c.35-1.88,2.12-3.9,6.41-5.86,1.29-.43,2.58-.83,3.85-1.22a1,1,0,0,0-.16-.12l1.23-.21,1.21-.36c1.6-.82,2.72-3.19,3.19-6.4-2.86.78-5.77,1.67-8.72,2.65C105.47,59.26,103.94,63.89,104.51,67.36Z"
        style="opacity:0.2"
      />
      <path
        d="M153.94,50.33c-9.48-.49-19.73.78-30.65,3.58a17.43,17.43,0,0,1-1.3,5.85c11.18-2.92,21.67-4.27,31.34-3.76,4.86.29,9.12.55,13,.82A17.12,17.12,0,0,1,164.45,51C161.25,50.77,157.78,50.57,153.94,50.33Z"
        style="opacity:0.2"
      />
      <path
        id="Schattenwurf_Eingang"
        data-name="Schattenwurf Eingang"
        d="M140.1,139.25a5.13,5.13,0,0,1-2.56-4c-.1-1.92-2.06-4.23-4.93-6.08-14.28,3.05-24.5,7.22-32.28,12.22,1.37,1.85,4.13.9,7.43,3.75,2,1.7,1.54,2.51,3.45,4.89,4.29,5.35,9.06,4.45,10.55,8.33,1.22,3.17-1.78,4.6-.76,6.53l.22.36c2.35-3.46,13.43-6.28,26.58-7.24a4.4,4.4,0,0,0,3.37,1.2c.25,0,1-.28,1.2-.29l.8-.42C152.62,149,144.87,141.59,140.1,139.25Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="Schattenwurf_Kurve1"
        data-name="Schattenwurf Kurve1"
        d="M301.52,119.17q-3.18,2.16-6.69,4.42a1.14,1.14,0,0,0,.19.19c1.1.88,3.73.15,5.48,2.22.92,1.08.64,1.81,1.5,2.83,1.48,1.77,3.92.45,6.17,1.84,5.91,3.65,9.56,10.52,11.52,15.23,8.16-4.76,14.73-8.68,15.06-9.32l-3.82-2c-3.55.12-6.48-1.61-9-4.7L310.76,124a14,14,0,0,1-7-3.66Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        id="Schattenwurf_Kurve2"
        data-name="Schattenwurf Kurve2"
        d="M275.66,195.1a1.11,1.11,0,0,0,.17-.27c.71-1.68-2.76-2.7-2.66-6.16.15-5.53,11.84-14.77,21.49-19.42-4.22-2.31-6.73-3.66-7-3.75S271.92,174,271.92,174a10,10,0,0,1-9.23,5.26l-7.52,4.28Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path
        d="M448.74,284,426.39,271.5c-.29,3.09.21,6.45,2.36,8.93a7.92,7.92,0,0,0,.71.71l20.62,11.57c-.1-.16-.2-.3-.3-.47C448.68,290.32,448.31,287.36,448.74,284Z"
        style="opacity:0.2"
      />
      <path
        d="M423.64,270,386.78,249.3a11.68,11.68,0,0,0,2.38,8.7,10.26,10.26,0,0,0,1.65,1.48l2.73,1.53.12.07,31.15,17.46c-.05-.08-.1-.15-.15-.24C423.54,276.36,423.18,273.35,423.64,270Z"
        style="opacity:0.2"
      />
      <path
        d="M384,247.75l-16.19-9.08c-.29,3.09.21,6.44,2.36,8.93a9.78,9.78,0,0,0,.72.72l14.57,8.17a6.57,6.57,0,0,1-.4-.62C384,254,383.6,251.05,384,247.75Z"
        style="opacity:0.2"
      />
      <path
        d="M365.06,237.13l-33.72-18.91a11.63,11.63,0,0,0,2.38,8.66,10.65,10.65,0,0,0,2,1.73l1.58.89a6.91,6.91,0,0,1,1.25.69h0l27.7,15.52a2,2,0,0,1-.16-.24C365,243.53,364.61,240.51,365.06,237.13Z"
        style="opacity:0.2"
      />
      <path
        d="M291.63,203.76c-1.12-1.95-1.48-5-1-8.37L266,181.58c-.31,3.15.16,6.68,2.24,9.18L291.76,204Z"
        style="opacity:0.2"
      />
      <path
        d="M263.25,180.06l-1-.57-7,4,8.83,4.95A14.46,14.46,0,0,1,263.25,180.06Z"
        style="opacity:0.2"
      />
      <path
        d="M328.57,216.67l-35.21-19.73c-.29,3.09.21,6.46,2.36,8.95a8.21,8.21,0,0,0,.66.66l33.69,18.89c-.15-.22-.3-.45-.44-.69C328.54,222.86,328.16,220,328.57,216.67Z"
        style="opacity:0.2"
      />
      <path
        d="M468.67,306.66c0,.08-.1.15-.14.24a10.65,10.65,0,0,1,2.2-4.77,7.69,7.69,0,0,1,.9-.91,17.26,17.26,0,0,0-6.77-8.15l-13.36-7.49a11.74,11.74,0,0,0,2.38,8.79,9.69,9.69,0,0,0,1.21,1.14l2.77,1.56c5.62,2.87,9,6.65,10.49,11.11A8.79,8.79,0,0,1,468.67,306.66Z"
        style="opacity:0.2"
      />
      <path
        d="M472.55,303.9a9.8,9.8,0,0,0-2.34,2.84,10.91,10.91,0,0,0-1.15,4.33c.84,5.42-.64,11.69-3.89,18.51a9.15,9.15,0,0,1,1.22-.79,9.72,9.72,0,0,1,3.46-1C473.57,318.74,474.33,310.41,472.55,303.9Z"
        style="opacity:0.2"
      />
      <path
        d="M156.26,151.2a14.69,14.69,0,0,1-2.31,6.45c15.83-.61,34.28.76,48.36,4.43a15.87,15.87,0,0,1-2.23-6.85A178.71,178.71,0,0,0,156.26,151.2Z"
        style="opacity:0.2"
      />
      <path
        d="M154,151.29c-18.6.88-34.08,5-37.39,12.54l3.86,3.6c.17-5,11.93-8.27,27.48-9.44l1.54-.18C151.51,157.6,153.12,155.06,154,151.29Z"
        style="opacity:0.2"
      />
      <path
        d="M202.93,155.91c.65,5.07,3.12,7.25,5.92,7.61-.2.13-.39.25-.58.35a56.43,56.43,0,0,1,5.31,2.13l8.2-2.94A75.47,75.47,0,0,0,202.93,155.91Z"
        style="opacity:0.2"
      />
      <path
        d="M386.44,107.83A77.34,77.34,0,0,0,367.83,115l8.5,2.17c2.22-.94,4.57-1.81,7-2.6C385,113.62,386.35,111.62,386.44,107.83Z"
        style="opacity:0.2"
      />
      <path
        d="M389.09,107.17a12.34,12.34,0,0,1-1.28,6.06,152,152,0,0,1,47-4.83,13,13,0,0,1-2.87-5.74A178.77,178.77,0,0,0,389.09,107.17Z"
        style="opacity:0.2"
      />
      <path
        d="M468.92,110.56a13,13,0,0,0,2.12,5l-1.21,1.33-.11.11a13.05,13.05,0,0,1-3.79-8.29c-7-3.62-18.4-5.56-31.19-6,1.12,4.15,3.52,5.87,6.11,6l-.13.09c11.71,1.18,22,3.94,28.85,8.39a.94.94,0,0,1,.09-.12,17.68,17.68,0,0,1,2.72-2.75A11.75,11.75,0,0,0,468.92,110.56Z"
        style="opacity:0.2"
      />
      <path
        d="M78.27,71.94a86.53,86.53,0,0,1-2.16-15.83C75.8,51.57,71.89,62,71.89,62a41.74,41.74,0,0,0,2.18,18.32A18.61,18.61,0,0,1,78.27,71.94Z"
        style="opacity:0.2"
      />
      <path
        d="M110.88,110.57h0a20.24,20.24,0,0,1-7.67-10.82c-3.21-2-6.6-4.46-10.54-7.42C85.53,87,81.61,81.69,79.33,75.4c-2.06,2.89-3.59,6.71-2.64,10.43a11.63,11.63,0,0,0,.58,1.56c.43.76.89,1.52,1.38,2.27A8.49,8.49,0,0,1,79.57,91h0A40.69,40.69,0,0,0,89.89,101c7.34,5,13.43,8.12,21.45,9.86C111.19,110.77,111,110.68,110.88,110.57Z"
        style="opacity:0.2"
      />
      <path
        d="M106.28,101.56a17,17,0,0,0,11.39,10.35c2.45.28,5.09.48,8,.59l.8.75c.71-1.5.91-3.3-.84-6.25l1.91-.08C118.68,106.71,112.61,105,106.28,101.56Z"
        style="opacity:0.2"
      />
      <path
        id="Licht1"
        d="M162.27,78.52c-.16,1.45-4-.58-8.08,0-3.75.53-6.43-.43-6.26-1.88s4.37-2.51,8-2.09S162.44,77.07,162.27,78.52Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        id="SchattenEingang"
        d="M145.6,118.44l-.3-16.22a22.12,22.12,0,0,1,.36-3.88V96.72s-4.79-21.5-8.5-11.52c-1.17,5.93-6.18,14.85-9.63,21.72l18,16.66Z"
        style="fill:#1d1d1b;opacity:0.4"
      />
      <path d="M147.52,207.54c-.09,0-.17,0-.27-.08l-3.16-.26Z" style="opacity:0.2" />
      <path d="M148.5,207.63l-1-.09A2.45,2.45,0,0,0,148.5,207.63Z" style="opacity:0.2" />
      <path
        d="M307.51,145.71l-20.18,12.46-14.45,8a11.74,11.74,0,0,1-1.25,8.18l16-8.88,13.64-8.37c-.26,0-.52,0-.8,0,0,0,4.55-2.17,5.59-3.71A10.94,10.94,0,0,0,307.51,145.71Z"
        style="opacity:0.2"
      />
      <path
        d="M215.15,192.72a190.09,190.09,0,0,1-53.65,8.11c-5.95-.16-12-.59-17.93-1.29.55,5.7,2.41,7.42,3.68,7.92,4.64.35,9.49.58,14.58.68a190.39,190.39,0,0,0,51.09-7.36C214.52,199.65,215.29,196.65,215.15,192.72Z"
        style="opacity:0.2"
      />
      <path
        d="M254.83,176.17A218.29,218.29,0,0,1,217.56,192a19.3,19.3,0,0,1-.76,7.64,217.35,217.35,0,0,0,38.37-16.15l7.71-4.27a.66.66,0,0,1-.14,0s.63-.29,1.48-.74l1.3-.72a10.76,10.76,0,0,0,3.07-2.34,10.9,10.9,0,0,0,1.41-7.64Z"
        style="opacity:0.2"
      />
      <path
        d="M87.89,173.88A28.29,28.29,0,0,1,84,161.17V167a35.62,35.62,0,0,0,4,14.71A17.94,17.94,0,0,1,87.89,173.88Z"
        style="opacity:0.2"
      />
      <path
        d="M90.26,177.35a16.72,16.72,0,0,0,4.32,12.85,43,43,0,0,0,7.78,5.82l1.19.48-.49-.08c9.88,5.63,23.4,9.08,40.13,10.69-.92-1.24-1.91-3.57-2.35-7.92C119.6,196.33,100,189.64,90.26,177.35Z"
        style="opacity:0.2"
      />
      <path
        d="M172.35,35.24c-1.63-.18-3.28-.31-4.93-.4a33.67,33.67,0,0,0-1.11,5.78c0,.17,0,.33,0,.5h1.4c12.22-.22,24,3.56,24.22,1.33S183.42,36.49,172.35,35.24Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M165.21,34.67c-9.13-.41-16.42.66-16.62,2.49-.24,2.06,5.69,3.91,15.58,4A46.29,46.29,0,0,1,165.21,34.67Z"
        style="fill:#fff;opacity:0.4"
      />
      <path
        d="M310.44,144.44l17.06-10.27a13.7,13.7,0,0,0,3.43.41l3.82,2c-1.78,1.61-12.56,7.85-25.42,15.64A12,12,0,0,0,310.44,144.44Z"
        style="opacity:0.2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SlideOverview",
  props: {
    index: { type: Number, default: 0 },
    color: { type: String, default: "" },
    overview: { type: Boolean, default: false },
    colorarray: { type: Array, default: () => [] }
  },
  data() {
    return {
      internalColor: "",
      internalColorArray: [],
      defaultColor: "orange"
    };
  },
  watch: {
    index: {
      handler: function(index) {
        if (this.internalColor.indexOf("#grad1_") >= 0)
          this.internalColor = "url(#grad1_" + index + ")";
        if (this.internalColor.indexOf("#grad2_") >= 0)
          this.internalColor = "url(#grad2_" + index + ")";
        if (this.internalColor.indexOf("#grad3_") >= 0)
          this.internalColor = "url(#grad3_" + index + ")";
      }
    },
    color: {
      handler: function(color) {
        switch (color) {
          case "rot":
            this.internalColor = "#e63232";
            break;
          case "grün":
            this.internalColor = "#8cc83c";
            break;
          case "blau":
            this.internalColor = "#14b4f0";
            break;
          case "weiß":
            this.internalColor = "#e6e6e6";
            break;
          case "gelb":
            this.internalColor = "#f0dc1e";
            break;
          case "magenta":
            this.internalColor = "#FF00FF";
            break;
          case "cyan":
            this.internalColor = "#00FFFF";
            break;
          case "Regenbogen":
            this.internalColor = "url(#grad1_" + this.index + ")";
            break;
          case "cyan-magenta-gelb":
            this.internalColor = "url(#grad2_" + this.index + ")";
            break;
          case "blau-weiß":
            this.internalColor = "url(#grad3_" + this.index + ")";
            break;
          case "gelb-rot":
            this.internalColor = "url(#grad4_" + this.index + ")";
            break;
          case "cyan-magenta":
            this.internalColor = "url(#grad5_" + this.index + ")";
            break;
          default:
            this.internalColor = this.defaultColor;
            break;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.mapColors(this.colorarray);
  },
  methods: {
    mapColors(colorArray) {
      for (let i = 0; i < colorArray.length; i++) {
        switch (colorArray[i].colorName) {
          case "rot":
            this.internalColorArray.push("#e63232");
            break;
          case "grün":
            this.internalColorArray.push("#8cc83c");
            break;
          case "blau":
            this.internalColorArray.push("#14b4f0");
            break;
          case "weiß":
            this.internalColorArray.push("#e6e6e6");
            break;
          case "gelb":
            this.internalColorArray.push("#f0dc1e");
            break;
          case "magenta":
            this.internalColorArray.push("#dc00dc");
            break;
          case "cyan":
            this.internalColorArray.push("#00dcdc");
            break;
          case "Regenbogen":
            this.internalColorArray.push("url(#grad1_" + i + ")");
            break;
          case "cyan-magenta-gelb":
            this.internalColorArray.push("url(#grad2_" + i + ")");
            break;
          case "blau-weiß":
            this.internalColorArray.push("url(#grad3_" + i + ")");
            break;
          case "gelb-rot":
            this.internalColorArray.push("url(#grad4_" + i + ")");
            break;
          case "cyan-magenta":
            this.internalColorArray.push("url(#grad5_" + i + ")");
            break;
        }
      }
    },
    emitSelect(selected) {
      this.$emit("selected", selected);
    }
  }
};
</script>

<style scoped>
.inactive {
  fill: #cccccc !important;
}

/*
.click:hover {
  fill: darkorange !important;
  cursor: pointer;
}
 */

.st0 {
  fill: #cccccc;
}
.st1 {
  fill: #f0dc1e;
}
.st2 {
  fill: #f08c1e;
}
.st3 {
  fill: #8cc83c;
}
.st4 {
  fill: #14b4f0;
}
.st5 {
  fill: #e63232;
}
.st6 {
  opacity: 0.2;
}
.st7 {
  opacity: 0.1;
}
.st8 {
  opacity: 0.7;
  fill: #ffffff;
}
.st9 {
  opacity: 0.6;
  fill: #ffffff;
}
.st10 {
  opacity: 0.4;
}
.st11 {
  opacity: 0.4;
  fill: #ffffff;
}
.st12 {
  fill: #ffffff;
}
.st13 {
  fill: #b3b3b3;
}
.st14 {
  opacity: 0.5;
}
.st15 {
  opacity: 0.07;
  fill: #ffffff;
}
</style>
